import { BudgetHome } from './budget/ui/BudgetHome'
import { CookbookScreen } from './cookbook/ui/CookbookScreen'
import { LogScreen } from './budget/ui/LogScreen'
import { SettingsScreen } from './budget/ui/SettingsScreen'
import { ExerciseScreen } from './exercise/ui/ExerciseScreen'
import { SpinnerScreen } from './game/ui/SpinnerScreen'
import { HealthScreen } from './health/ui/HealthScreen'
import { NutritionScreen } from './nutrition/ui/NutritionScreen'
import { SavingsScreen } from './savings/ui/SavingsScreen'
import { BottomNav } from './shell/BottomNav'
import { Dashboard } from './shell/Dashboard'
import { EmergencyScreen } from './shell/EmergencyScreen'
import { LoginScreen } from './shell/LoginScreen'
import { OtherScreen } from './shell/OtherScreen'
import { SettingsSection } from './shell/SettingsSection'
import { TodoScreen } from './todo/ui/TodoScreen'
import { useRoute } from './lib/router'
import { useStore } from './store'

export function App() {
  const route = useRoute()
  const { status, snapshot, offline } = useStore()

  // Nothing of the app renders until a session exists — not even a skeleton of the
  // dashboard. The data endpoints refuse unauthenticated requests too, so the gate is not
  // merely cosmetic.
  if (status === 'loading') {
    return <div className="login" />
  }

  if (status === 'anonymous') {
    return <LoginScreen />
  }

  if (!snapshot) {
    return (
      <div className="screen">
        <div className="topbar">
          <h1>Loading…</h1>
        </div>
      </div>
    )
  }

  return (
    <>
      {offline ? <div className="offline-bar">Offline — showing your last saved data</div> : null}
      <Screen route={route} />
      <BottomNav route={route} />
    </>
  )
}

function Screen({ route }: { route: string }) {
  switch (route) {
    case '/budget':
      return <BudgetHome />
    case '/budget/log':
      return <LogScreen />
    case '/budget/settings':
      return <SettingsScreen />
    case '/nutrition':
      return <NutritionScreen />
    case '/health':
      return <HealthScreen />
    case '/todo':
      return <TodoScreen />
    case '/other':
      return <OtherScreen />
    case '/settings':
      return <SettingsSection />
    case '/savings':
      return <SavingsScreen />
    case '/cookbook':
      return <CookbookScreen />
    case '/emergency':
      return <EmergencyScreen />
    case '/exercise':
      return <ExerciseScreen />
    case '/sex-game':
      return <SpinnerScreen />
    default:
      return <Dashboard />
  }
}
